import * as React from 'react';

import FileCopy16 from './FileCopy16';

export const fileCopy16 = () => <FileCopy16 />;

export default {
    title: 'Icon/Fill/FileCopy16',
    component: FileCopy16,
    parameters: {
        notes: "`import FileCopy16 from 'box-ui-elements/es/icon/fill/FileCopy16';`",
    },
};
